var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "group-list-email-modal",
      "centered": "",
      "size": "md",
      "no-close-on-backdrop": ""
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "title-text"
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Send Email")])])]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.sendEnrollmentEmail.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('label', {
    staticClass: "modal-label-prudential font-bold",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(" Email Address ")]), _c('span', {
    staticClass: "input-required"
  }, [_vm._v("*")]), _c('br'), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.email,
      expression: "form.email"
    }],
    staticClass: "w-100 group-email-input  mb-3",
    class: {
      'group-email-is-invalid': _vm.showError('email')
    },
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": "Enter your email address"
    },
    domProps: {
      "value": _vm.form.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }

        _vm.$set(_vm.form, "email", $event.target.value);
      }
    }
  }), _vm.showError('email') ? _c('div', {
    staticClass: "group-email-error-message"
  }, [_vm._v(" Please enter a valid email address ")]) : _vm._e()])]), _c('div', {
    staticClass: "row justify-content-end payment-download"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }